import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeModal } from "../../reducers/modalReducer";
import { Modal } from "@allaria-tech/matter/Modal";
import { Typography } from "@allaria-tech/matter/Typography";
import useMobileLayout from "../../hooks/useMobileLayout";

import OldDNI from "../../assets/images/oldDNI.svg?react";
import NewDNI from "../../assets/images/newDNI.svg?react";

import styles from "./TramitNumberModal.module.scss";

const TramitNumberModal = () => {
  const { wrapper, dniPhotos, cryptoDniPhotos, dniPhoto } = styles;

  const dispatch = useAppDispatch();
  const { modalName } = useAppSelector((state) => state.modal);
  // In the app's 560px desktop modal our width reads as a phone, so keep the
  // desktop dialog there; its frame grows to fit it, so no 85vh cap.
  const { isCryptoAppModal } = useMobileLayout();

  const handleClose = () => dispatch(closeModal());

  return (
    <Modal
      isOpen={modalName === "modal-tramit-number"}
      onClose={handleClose}
      title="¿Dónde encuentro mi número de trámite?"
      primaryAction={{
        text: "Cerrar",
        onClick: handleClose,
      }}
      footerAlignment={isCryptoAppModal ? "center" : "right"}
      disableMobileLayout={isCryptoAppModal}
      disableMaxHeight={isCryptoAppModal}
    >
      <div className={wrapper}>
        <div>
          <Typography type="BODY" size="S">
            Si tu DNI es posterior al 2013 encontralo en el frente.
          </Typography>
          <Typography type="BODY" size="S">
            Si es previo, encontralo en el dorso.
          </Typography>
        </div>
        <div
          className={`${dniPhotos} ${isCryptoAppModal ? cryptoDniPhotos : ""}`}
        >
          <NewDNI className={dniPhoto} />
          <OldDNI className={dniPhoto} />
        </div>
      </div>
    </Modal>
  );
};

export default TramitNumberModal;
